import React, { useEffect, useState } from 'react';
import '../styles/About.css';

// Slideshow images
import slide1 from "../assets/slider1.jpg";
import slide3 from "../assets/slider3.jpg";
import slide4 from "../assets/slider4.jpg";

const slides = [slide1, slide3, slide4];

const Slideshow = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="glb-slideshow-box">
      {slides.map((slide, index) => (
        <img
          key={index}
          src={slide}
          alt={`Slide ${index + 1}`}
          className={`glb-slide-img ${index === current ? 'active' : ''}`}
        />
      ))}
    </div>
  );
};

const AboutPage = () => {
  return (
    <div className="glb-about-wrapper">

      {/* Welcome Header */}
      <div className="glb-about-header">
        <h1>ABOUT </h1>
        <span>SCHOOL</span>
      </div>

      {/* Welcome Section */}
      <div className="glb-welcome-section">
        <div className="glb-welcome-content">

          <div className="glb-welcome-text">
            <h1>SETH. G.L. BIHANI SCHOOL</h1>
            <p>
              A warm welcome to Seth. G.L Bihani Sc Sec. School in SriGanganagar! It is our honour
              and privilege to have you as part of our prestigious institution. As you embark on this
              new educational journey, we extend our heartfelt greetings and best wishes for your
              success. At Seth. G.L Bihani Sc Sec. School, we are committed to providing our
              students with an enriching and transformative learning experience.
            </p>
            <p>
              Our dedicated faculty and staff strive to create an environment where intellectual
              curiosity, creativity, and personal growth are nurtured. We believe that every student
              has unique talents and potential, and our goal is to help you discover and develop
              those talents to the fullest.
            </p>
            <p>
              As you begin your journey at Seth. G.L Bihani Sc Sec. School, we encourage you to
              embrace new experiences, challenge yourself intellectually, and actively engage with
              your peers and teachers. We are confident that your time here will be filled with
              growth, discovery, and lifelong memories.
            </p>
          </div>

          {/* Slideshow */}
          <Slideshow />

        </div>
      </div>

    </div>
  );
};

export default AboutPage;